<app-popup-header [attr.aria-label]="'Popup header ' + data.title"
                  [title]="data.title"
                  [showBorder]="data.layoutConfig?.showHeaderBorder"
                  (closePopup)="onClose()" />

<mat-dialog-content [attr.aria-label]="'Popup content ' + data.title">
  <div class="pb-5" [innerHTML]="contentData | translate | nl2br"></div>
</mat-dialog-content>

<app-popup-footer [ngClass]="footerClass"
                  [attr.aria-label]="'Popup footer ' + data.title"
                  *ngIf="data.buttons && data.buttons.length > 0"
                  [buttons]="data.buttons" />
